/* global __CONFIG__ */

export default __CONFIG__
